<div class="flex flex-row flex-1 page-content">
  <div class="flex-1 h-full bg-gris-4">
    <router-outlet></router-outlet>
  </div>
</div>
